import { render, staticRenderFns } from "./TheToolbar.vue?vue&type=template&id=65a37ea2&"
import script from "./TheToolbar.vue?vue&type=script&lang=js&"
export * from "./TheToolbar.vue?vue&type=script&lang=js&"
import style0 from "./TheToolbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports